// Shared (client+server safe) referral helpers.

/**
 * @deprecated Stripe coupon-based crediting was removed in Batch R1.
 * Referrals now credit via /api/public/cron/referrals-maturation when
 * the referred user completes 30 calendar days AND logs on >= 7 distinct
 * days in their first 30 days. Constants kept only so legacy server-side
 * helpers compile; do not use in new code.
 */
export const REFERRAL_COUPON_ID = "knowmeno_referral_v1";
export const REFERRAL_COUPON_NAME = "KnowMeno Referral — 1 Free Month";
/** @deprecated see file header. */
export const REFERRAL_COUPON_AMOUNT_OFF = 1499;

export const REFERRAL_CAP_PER_YEAR = 12;
export const REFERRAL_CAP_WINDOW_DAYS = 365;

// New maturation rules (Batch R1).
export const REFERRAL_MATURATION_DAYS = 30;
export const REFERRAL_MIN_ENGAGED_DAYS = 7;

export function shareUrlForCode(code: string, _origin?: string): string {
  return `https://knowmeno.com/?ref=${encodeURIComponent(code)}`;
}

export function shareTextForCode(code: string, _origin?: string): string {
  const url = shareUrlForCode(code);
  return `I've been using KnowMeno to track my menopause symptoms and bring real data to my doctor 💜 Try it free for 7 days — and if you subscribe, you get a free month. ${url}`;
}

export function isValidReferralCode(code: string | null | undefined): boolean {
  if (!code) return false;
  return /^[A-HJ-NP-Z2-9]{8}$/.test(code);
}
